import { render, staticRenderFns } from "./MailOK.vue?vue&type=template&id=933b34ba&"
import script from "./MailOK.vue?vue&type=script&lang=js&"
export * from "./MailOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports